import Card from "@pathwright/ui/src/components/card/Card"
import CardBlock from "@pathwright/ui/src/components/card/CardBlock"
import { Card as CardT } from "@pathwright/ui/src/components/card/types"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import PropTypes from "prop-types"
import {
  FeatureAction,
  FeatureContextInput,
  FeatureKey
} from "@pathwright/graphql-client/src/generated"
import FeatureBlockContainer from "../block/FeatureBlockContainer"
import FeaturePermissionsForm from "../form/FeaturePermissionsForm"
import { featureKeyPropType } from "../propTypes"
import { getFeatureInfo } from "../utils"
import withFeatureContext from "./withFeatureContext"

const ManageFeaturePermissions = withFeatureContext(
  ({
    card,
    featureKey,
    context
  }: {
    card: CardT
    featureKey: FeatureKey
    context: FeatureContextInput
  }) => {
    const { t } = useTranslate()
    const { title } = getFeatureInfo(featureKey, t)

    return (
      <Card
        card={card}
        title={t("{{ feature }} visibility", {
          feature: title
        })}
        noaction
        emphasis="secondary"
      >
        <CardBlock paddingTop={false}>
          <FeatureBlockContainer
            featureKey={featureKey}
            featureAction={FeatureAction.View}
            context={context}
          />
          <FeaturePermissionsForm featureKey={featureKey} context={context} />
        </CardBlock>
      </Card>
    )
  }
)

ManageFeaturePermissions.displayName = "ManageFeaturePermissions"

ManageFeaturePermissions.propTypes = {
  // provided by CardStack > CardStackCard
  // card: PropTypes.object.isRequired,
  featureKey: featureKeyPropType.isRequired,
  ...PropTypes.shape({ ...withFeatureContext._propTypes })
}

export default ManageFeaturePermissions
